package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2023_12_15_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who have just escaped a surprise run-in with the Carnage Crew without spilling any blood.  The heroes continue to the Traveler’s Doorstep to pick up Falorn’s crossbow, return to the inn for lunch, and then head out for their meeting with Lady Aventary of the Peers.  Lady Aventary, the other Peers, and Malus military/guard types mostly recap the plan from Newgrowth 37 (teleport to Rognirak, travel to Zedj by Horse, and save the world). Lady Aventary points out the caves just north of Zedj as a good starting point. Goram inform the room about the planned interview tomorrow with the city guard. He learns that the city guard had followed the Carnage Crew but they vanished after entering a warehouse. Our heroes learn that Samual Thardose of Brij may be working with Darvidia.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper and Tuesday go on an aerial adventure while the others return to the inn.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes attend the Hexagon Party Battle Open where Bigglesworth bets 5 gold on “Dwarves Assembly.” During the event, Annette spots Matty Footseller in the crowd and tells the others.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In last week’s summary, we incorrectly reported Goram’s lost family connection which should have been Sir Sorlon Dragstone (a high level officer in the Malusian Calvary). We regret the error.")
    }
}
